// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/additional_services/lista.
 *
 * Returns the list of active additional services for selection in the
 * service-orders module.
 */
import type { AdditionalServices_ListaRow } from './AdditionalServices_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type AdditionalServices_ListaResponseDados = AdditionalServices_ListaRow[];

export type AdditionalServices_ListaResponse = ApiResponse<AdditionalServices_ListaResponseDados>;

registerResponseContract('AdditionalServices_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_additional_service_id:                       { type: 'number',  required: true },
      so_additional_service_category_id:              { type: 'number',  required: true },
      so_additional_service_name:                     { type: 'string',  required: true },
      so_additional_service_description:              { type: 'string',  required: false },
      so_additional_service_default_price:            { type: 'number',  required: true },
      so_additional_service_additional_deadline_days: { type: 'number',  required: false },
      so_additional_service_active:                   { type: 'number',  required: true },
      so_additional_service_created_at:               { type: 'string',  required: false },
      so_service_category_name:                       { type: 'string',  required: false },
      category_name:                                  { type: 'string',  required: false },
      so_additional_service_franchise_id:             { type: 'number',  required: false },
    },
  },
})
